<template>
  <b-container>
    <b-row
      ><b-col md="12"><h2 class="text-left">Programok</h2></b-col></b-row
    >
    <b-row
      ><b-col md="12 mb-4"
        ><button type="button" name="button" class="btn btn-primary mb-1 float-left" @click="createClicked()">
          Új program hozzáadása
        </button></b-col
      ></b-row
    >
    <b-row>
      <b-col md="4" v-for="(p, index) in programs" v-bind:key="p._id" class="mb-1 mb-0 mr-0">
        <p>{{ p.order }}.</p>
        <program-card
          :name="p.name"
          :code="p.code"
          :link="p.link"
          :status="p.status"
          :color="index % 3 === 0 ? 'green' : index % 2 === 0 ? 'blue' : 'red'"
        />
        <b-row>
          <b-col md="6 mr-0 ml-0"
            ><button
              v-if="index !== 0"
              type="button"
              name="button"
              class="btn btn-secondary add-button"
              @click="leftClicked(index)"
            >
              {{ left }}
            </button>
          </b-col>
          <b-col md="6 mr-0 ml-0"
            ><button
              v-if="index !== programs.length - 1"
              type="button"
              name="button"
              class="btn btn-secondary add-button"
              @click="rightClicked(index)"
            >
              {{ right }}
            </button>
          </b-col>
        </b-row>
        <b-row
          ><b-col md="12"
            ><button type="button" name="button" class="btn btn-primary add-button mt-3" @click="editClicked(p._id)">
              Szerkesztés
            </button></b-col
          ></b-row
        ><b-row
          ><b-col md="12"
            ><button
              type="button"
              name="button"
              class="btn btn-secondary add-button mt-3 mb-3"
              @click="deleteClicked(p._id)"
            >
              Törlés
            </button></b-col
          ></b-row
        ></b-col
      >
    </b-row>
  </b-container>
</template>
<script>
import { deleteProgram, listPrograms, reorderPrograms } from '../../api/program'
import ProgramCard from './components/ProgramCard.vue'
import { PROGRAM_STATUS, getReadableProgramStatus } from './models/programStatus'
export default {
  components: { ProgramCard },
  name: 'Program',
  data: function() {
    return {
      loading: true,
      programs: [],
      left: '<--',
      right: '-->'
    }
  },
  // computed: {
  //   programLength: function() {
  //     return this.programs.length
  //   }
  // },
  methods: {
    getReadableStatus: function(status) {
      return getReadableProgramStatus(status)
    },
    getStatusColor: function(status) {
      switch (status) {
        case PROGRAM_STATUS.REGISTRATION_OPEN:
          return 'green'
        case PROGRAM_STATUS.REGISTRATION_CLOSED:
          return 'red'
        case PROGRAM_STATUS.PREQUALIFICATION_CLOSED:
          return 'red'
        case PROGRAM_STATUS.PREQUALIFICATION_OPEN:
          return 'green'
      }
    },
    createClicked: function() {
      this.$router.push('/contents/programs/create')
    },
    editClicked: function(id) {
      this.$router.push({ path: '/contents/programs/edit', query: { id } })
    },
    deleteClicked: async function(id) {
      await deleteProgram(id)
      await this.fetchPrograms()
    },
    fetchPrograms: async function() {
      const programs = await listPrograms()
      this.programs = programs
    },
    leftClicked: async function(index) {
      let updatedPrograms = [...this.programs.map(program => ({ id: program._id, order: program.order }))]
      const currentProgram = updatedPrograms[index]
      const beforeProgram = updatedPrograms[index - 1]
      updatedPrograms[index] = { id: beforeProgram.id, order: beforeProgram.order + 1 }
      updatedPrograms[index - 1] = { id: currentProgram.id, order: currentProgram.order - 1 }
      await reorderPrograms(updatedPrograms)
      await this.fetchPrograms()
    },
    rightClicked: async function(index) {
      let updatedPrograms = [...this.programs.map(program => ({ id: program._id, order: program.order }))]
      updatedPrograms[index] = { id: updatedPrograms[index].id, order: updatedPrograms[index].order + 1 }
      updatedPrograms[index + 1] = { id: updatedPrograms[index + 1].id, order: updatedPrograms[index + 1].order - 1 }
      await reorderPrograms(updatedPrograms)
      await this.fetchPrograms()
    }
  },
  created: async function() {
    await this.fetchPrograms()
  }
}
</script>
<style scoped>
.program-container {
  margin-left: 25px;
  margin-right: 25px;
}

.add-button {
  width: inherit;
}

p {
  text-align: left;
  margin-bottom: 3px;
}
</style>
